// extracted by css-extract-rspack-plugin
var _1 = "NY7yzFYajIxALr_x";
var _2 = "qnYGo1cZMjEmKQjU";
export { _1 as "column", _2 as "demand" }
